import request from '@/utils/request'
const apiPath = '/cust_service/custServiceArchiveGroup'
import { downloadBlob } from '@/utils/download'
const custServiceArchiveGroupApi = {
  /**
   * 新增【归档管理】
   */
  create(data) {
    return request.post(apiPath + '/tee', data)
  },
  /**
   * 修改【归档管理】
   */
  update(data) {
    return request.put(apiPath + '/tee', data)
  },
  /**
   * 分页查询【归档管理】
   */
  fetchList(query) {
    return request.get(apiPath + '/tee', { params: query })
  },
  fetchForList(query) {
    return request.get(apiPath + '/tee/listForMini', { params: query })
  },
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query })
  },
  /**
   * 查看【归档管理】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【归档管理】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  setIsEnable(data) {
    return request.put(apiPath + '/tee/setIsEnable', data)
  },
  exportExcel(query) {
    return request.get(`${apiPath}/export`, { responseType: 'blob', params: query })
      .then(res => downloadBlob(res, '归档管理.xlsx'))
  },
}
export default custServiceArchiveGroupApi
